<template>
    <span>
        {{ formattedTimestamp }}
    </span>
</template>

<script>
    import moment from 'moment'

    export default {
        name: 'FormattedTimestamp',
        props: {
            value: {
                type: [String, Object],
                required: true,
            },
            format: {
                type: String,
                default() {
                    return 'LLLL'
                }
            },
            utc: {
                type: Boolean,
                default() {
                    return false
                }
            }
        },
        computed: {
            formattedTimestamp() {
                if (this.utc) {
                    return moment.utc(this.value).local().format(this.format)
                }

                return moment(this.value).format(this.format)
            },
        },
    }
</script>
